import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const uploadBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_UPLOAD_BASE_URL
});

export default uploadBaseQuery;
